<template>
  <div class="page-wrapper">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 16px 24px 100px 24px;

  @media (min-width: 374px ) {
    padding-left: 32px;
    padding-right: 32px;
  }
  @media (min-width: 600px ) {
    max-width: 600px;
    margin: 0 auto;
  }
}
</style>
